import * as React from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

//https://docs.google.com/forms/d/e/1FAIpQLSeCZYKaeO00JG4CoIPc6QpYoaxvtUvy0VU-UAmbQDjpTsJppg/viewform?usp=pp_url&entry.1234531057=2AV&entry.1306139411=Charles&entry.1432230702=123456

export default function IncidentModal(props) {
  const open = props.open;

  return (
    <>
      <Dialog
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth
        maxWidth="md"
        onClose={() => props.setOpen(false)}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          New Incident
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={() => props.setOpen(false)}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <div
            style={{ width: "100%", display: "flex", justifyContent: "center" }}
          >
            <iframe
              src={`https://docs.google.com/forms/d/e/1FAIpQLSeCZYKaeO00JG4CoIPc6QpYoaxvtUvy0VU-UAmbQDjpTsJppg/viewform?usp=pp_url&embedded=true&entry.1234531057=${props.studentInfo[5]}&entry.1306139411=${props.studentInfo[4]}&entry.1432230702=${props.studentInfo[1]}`}
              width="800"
              height="1800"
              frameborder="0"
              marginheight="0"
              marginwidth="0"
            >
              Loading…
            </iframe>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => props.setOpen(false)} autoFocus>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
